import { Injectable } from '@angular/core';

@Injectable()
export abstract class AbstractLogoutAdaptor {
  abstract onLogout(source: string): void;
}
